// extracted by mini-css-extract-plugin
module.exports = {"wrap":"group_view_item_wrap__NT3c8","delete":"group_view_item_delete__3QrFF","full":"group_view_item_full__9YRB7","valueWrap":"group_view_item_valueWrap__2XSSt"};